import { connect } from 'react-redux'

import {
  resetReport as onResetReport
} from '../../actions/resetReportActions'

const mapDispatchToProps = {
  onResetReport
}

const withResetReport = Component => connect(null, mapDispatchToProps)(Component)

export { withResetReport }